import { useState, useMemo, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  Divider,
  FormLabel,
  AppBar,
  IconButton,
  Tab,
  Tooltip,
  Typography,
  CardContent,
} from "@material-ui/core";

import PageviewIcon from "@mui/icons-material/Pageview";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";

import { TabContext, TabList } from "@material-ui/lab";

import HeaderClientes from "components/_refactor/headers/clients";
import PhoneWithWhatsapp from "components/Texts/PhoneWithWhatsapp";
import EmailWithCopyAndSend from "components/Texts/EmailWithCopyAndSend";
import Snackbar from "components/Alerts/Snackbar";
import NotFound from "components/Texts/NotFound";

import componentStyles from "assets/theme/views/index";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import useLogs from "hooks/logs";

import { useTour } from "@reactour/tour";
import { useWebsocketFetchFinancialDocs } from "hooks/useWebsocketFetchFinancialDoc";
import { useWebsocketFetchInvoices } from "hooks/useWebsocketFetchInvoices";
import { useWebsocketFetchOrders } from "hooks/useWebsocketFetchOrders";
import { useVisionLogin } from "hooks/useVisionLogin";
import { useDebounce } from "hooks/useDebounce";
import FilterCard from "components/_refactor/filter-card";
import { IsMobile, IsMobile900 } from "utils/is-mobile";
import { API_ENV } from "constants/environment";
import DadosGeraisView from "./views/DadosGeraisView";
import PedidosView from "./views/PedidosView";
import NotasFiscaisView from "./views/NotasFiscaisView";
import TitulosFinanceirosView from "./views/TitulosFinanceirosView";
import PeriodField from "components/_refactor/fields/period-field";
import { getPeriodLabel } from "components/_refactor/fields/period-field";
import { IsSmall } from "utils/is-mobile";

const brands = JSON.parse(localStorage.getItem("usuarioMarcas")) || [];

const useStyles = makeStyles({
  ...componentStyles,
  appBar: {
    marginTop: "-4.5rem",
  },
  tab: {
    maxWidth: "max-content",
  },
});

const dataHoje = new Date().toISOString().slice(0, 10);

const getSelectedStore = (stores) => {
  return stores.find((store) => store.Selecionado);
};

const EditableEconomicGroupStore = ({
  stores,
  changeStore,
  mobile,
  mobile1100,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedStore, setSelectedStore] = useState(getSelectedStore(stores));

  useEffect(() => {
    const selectedStore = getSelectedStore(stores);

    setSelectedStore(selectedStore);
  }, [stores]);

  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  const handleChangeStore = async () => {
    if (!selectedStore.Selecionado) {
      await changeStore(null, selectedStore?.Cnpj, true);
    }

    toggleEditing();
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      style={{ alignSelf: "flex-start", marginTop: "0.5rem" }}
    >
      <FormLabel>Lojas Grupo Econômico</FormLabel>
      {isEditing ? (
        <Box display="flex" alignItems="center">
          <>
            <AutoCompleteField
              onChange={setSelectedStore}
              value={selectedStore}
              options={stores}
              customTooltipText={(option) =>
                typeof option === "object"
                  ? `${option?.Cnpj} - ${option?.Nome}`
                  : ""
              }
            />
            <Tooltip
              title="Cancelar alteração"
              style={{ marginLeft: 4, marginRight: 4 }}
            >
              <IconButtonLoader
                aria-label="botao para cancelar alteracao de loja"
                size="small"
                extraStyle={{
                  width: 10,
                  height: 10,
                }}
                onClick={toggleEditing}
                icon={<CancelIcon />}
              />
            </Tooltip>
            <Tooltip title="Confirmar alteração">
              <IconButtonLoader
                aria-label="botao para confirmar alteracao de loja"
                size="small"
                extraStyle={{
                  width: 10,
                  height: 10,
                }}
                onClick={handleChangeStore}
                icon={<DoneIcon />}
                disabled={!selectedStore || !selectedStore?.Id}
              />
            </Tooltip>
          </>
        </Box>
      ) : (
        <Box display="flex" alignItems="center">
          <Typography variant="body2">
            {selectedStore?.Nome || selectedStore?.Cnpj}
          </Typography>
          <EditIcon onClick={toggleEditing} style={{ marginLeft: ".5rem" }} />
        </Box>
      )}
    </Grid>
  );
};

const financialPeriod = [
  {
    name: "Emissão",
    value: "EMISSAO",
  },
  {
    name: "Vencimento",
    value: "VENCIMENTO",
  },
];

const financialStatus = [
  {
    name: "Abertos",
    value: "ABERTOS",
  },
  {
    name: "A vencer",
    value: "AVENCER",
  },
  {
    name: "Pagos",
    value: "PAGOS",
  },
  {
    name: "Vencidos",
    value: "VENCIDOS",
  },
  {
    name: "Todos",
    value: "TODOS",
  },
];

export default function Lojista360() {
  const { isOpen, setIsOpen, setCurrentStep, currentStep } = useTour();
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const [registeredUserId, setRegisteredUserId] = useState(null);
  const [formType, setFormType] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const hasAccessToUserRegister = JSON.parse(
    localStorage.getItem("userDetail") || "[]"
  )?.ViewsMenu?.some((item) => item.NomeInterno === "AdminPortalUsuario");

  const {
    dataFinancial,
    handleFetchDataFinancial,
    handleFetchUrlFinancial,
    statusFinancial,
  } = useWebsocketFetchFinancialDocs({
    onSuccessFinancial: handleGetTableDataFinancial,
  });
  const {
    dataInvoices,
    handleFetchDataInvoices,
    handleFetchUrlInvoices,
    statusInvoices,
  } = useWebsocketFetchInvoices({
    onSuccessInvoices: handleGetTableDataInvoices,
  });
  const {
    dataOrders,
    handleFetchDataOrders,
    handleFetchUrlOrders,
    statusOrders,
  } = useWebsocketFetchOrders({ onSuccessOrders: handleGetTableDataOrders });

  const { userId } = useVisionLogin();

  let api = API_ENV;

  const [valueTab360, setValueTab360] = useState("1");
  const [showCardStore, setShowCardStore] = useState(false);
  const [showCardPedidos, setShowCardPedidos] = useState(false);
  const [showCardNotaFiscal, setShowCardNotaFiscal] = useState(false);
  const [showCardFinanceiro, setShowCardFinanceiro] = useState(false);
  const [showCardRepresentante, setShowCardRepresentante] = useState(false);
  const [showCNPJNotFound, setShowCNPJNotFound] = useState(false);
  const [cnpj, setCnpj] = useState("");
  const [_cnpj, _setCnpj] = useState("");
  const [storeFilter, setStoreFilter] = useState("");
  const debouncedStoreFilter = useDebounce(storeFilter, 500);

  const [codigoProduto, setCodigoProduto] = useState("");
  const [cnpjRepresentante, setCnpjRepresentante] = useState("");
  const [periodoPedidos, setPeriodoPedidos] = useState();
  const [periodoNotasFiscais, setPeriodoNotasFiscais] = useState();
  const [periodoTitulos, setPeriodoTitulos] = useState();
  const [periodoCompraSellIn, setPeriodoCompraSellIn] = useState();
  const [dataInicialCompraSellin, setDataInicialCompraSellin] =
    useState(dataHoje);
  const [dataInicialPedidos, setDataInicialPedidos] = useState(dataHoje);
  const [dataInicialNotasFiscais, setDataInicialNotasFiscais] =
    useState(dataHoje);
  const [dataInicialTitulos, setDataInicialTitulos] = useState(dataHoje);
  const [dataFinalCompraSellin, setDataFinalCompraSellin] = useState(dataHoje);
  const [dataFinalPedidos, setDataFinalPedidos] = useState(dataHoje);
  const [dataFinalNotasFiscais, setDataFinalNotasFiscais] = useState(dataHoje);
  const [dataFinalTitulos, setDataFinalTitulos] = useState(dataHoje);
  const [periodoFinanceiro, setPeriodoFinanceiro] = useState(
    financialPeriod[0]
  );
  const [statusFinanceiro, setStatusFinanceiro] = useState(financialStatus[4]);

  const [storeRegistrationData, setStoreRegistrationData] = useState(null);
  const [storeListOrders, setStoreListOrders] = useState(null);
  const [storeNotasFiscais, setStoreNotasFiscais] = useState(null);
  const [storeRepresentatives, setStoreRepresentatives] = useState(null);
  const [storeFinancial, setStoreFinancial] = useState(null);
  const [pesquisando, setPesquisando] = useState(false);
  const [pesquisandoLojista, setPesquisandoLojista] = useState(false);
  const [pesquisandoRepresentante, setPesquisandoRepresentante] =
    useState(false);
  const [pesquisandoPedidos, setPesquisandoPedidos] = useState(false);
  const [pesquisandoTitulos, setPesquisandoTitulos] = useState(false);
  const [pesquisandoNotasFiscais, setPesquisandoNotasFiscais] = useState(false);

  const [msgErro, setMsgErro] = useState("");
  const [openErroLojista, setOpenErroLojista] = useState(false);
  const [openErroRepresentante, setOpenErroRepresentante] = useState(false);
  const [openErroPedidos, setOpenErroPedidos] = useState(false);
  const [openErroFinanceiro, setOpenErroFinanceiro] = useState(false);

  const [msgInfo, setMsgInfo] = useState("");
  const [openInfoLojista, setOpenInfoLojista] = useState(false);
  const [openInfoRepresentante, setOpenInfoRepresentante] = useState(false);
  const [openInfoPedidos, setOpenInfoPedidos] = useState(false);
  const [openInfoFinanceiro, setOpenInfoFinanceiro] = useState(false);

  const [codigo, setCodigo] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [nomeContato, setNomeContato] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");
  const [numeroProposta, setNumeroProposta] = useState("");
  const [numeroNF, setNumeroNF] = useState("");
  const [pesquisandoCNPJ, setPesquisandoCNPJ] = useState(false);
  const [listStores, setListStores] = useState(null);
  const [dadosBignumberFinanceiro, setDadosBignumberFinanceiro] = useState({});

  const [groupNameList, setGroupNameList] = useState([]);
  const [groupName, setGroupName] = useState(
    groupNameList?.length === 1 && groupNameList[0]
  );
  const [loadingGroupName, setLoadingGroupName] = useState(false);

  const [socialName, setSocialName] = useState("");
  const [socialNameList, setSocialNameList] = useState([]);
  const [loadingSocialName, setLoadingSocialName] = useState(false);
  const [showCreditLimit, setShowCreditLimit] = useState(true);
  const verifyTutorialStepOne = localStorage.getItem("lojistaStep1");
  const verifyTutorialStepFour = localStorage.getItem("lojistaStep4");
  const [brandDefaultValue] = useState({ IdMarca: 0, Nome: "Todas" });
  const [marcaPedido, setMarcaPedido] = useState(null);
  const [marcaTitulo, setMarcaTitulo] = useState(null);
  const [marcaNotaFiscal, setMarcaNotaFiscal] = useState(null);

  const [invoiceStatusList, setInvoiceStatisList] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [clearFiltersTab2, setClearFiltersTab2] = useState(false);
  const [clearFiltersTab3, setClearFiltersTab3] = useState(false);
  const [clearFiltersTab4, setClearFiltersTab4] = useState(false);
  const [isSearchingRegisteredUser, setIsSearchingRegisteredUser] =
    useState(false);

  const [lastSearchParamsOrders, setLastSearchParamsOrders] = useState(null);
  const [lastSearchParamsNotasFiscais, setLastSearchParamsNotasFiscais] =
    useState(null);
  const [lastSearchParamsTitles, setLastSearchParamsTitles] = useState(null);

  const isMobile = IsMobile();
  const isMobile900 = IsMobile900();
  const isMobile1100 = IsSmall();

  const itemXS6 = useMemo(() => (isMobile ? 12 : 6), [isMobile]);
  const itemXS4 = useMemo(() => (isMobile ? 12 : 4), [isMobile]);
  const itemXS3 = useMemo(() => (isMobile ? 12 : 3), [isMobile]);
  const itemXSResponsive = isMobile
    ? 12
    : isMobile900
    ? 6
    : isMobile1100
    ? 4
    : 3;
  const itemXSBigNumbersPedidos = isMobile1100 ? itemXS6 : itemXS3;
  const itemXSBigNumbersTitulos = isMobile1100 ? itemXS6 : itemXS4;

  useEffect(() => {
    const checkRegistration = async () => {
      try {
        const response = await Api.get(
          "user-info-register",
          "configuracoesOmni",
          `?cnpj=${storeRegistrationData.CnpjCpfPessoa}`
        );

        setRegisteredUserId(response?.Result.IdUsuario);
      } catch (error) {
        console.log(error);
      }
    };

    if (!!storeRegistrationData?.CnpjCpfPessoa && hasAccessToUserRegister) {
      checkRegistration();
    }
  }, [storeRegistrationData?.CnpjCpfPessoa]);

  useEffect(() => {
    const fetchList = async () => {
      setIsSearchingRegisteredUser(true);
      try {
        const { Success, Result } = await Api.get(
          "list-user",
          "adminportal",
          "",
          true
        );
        if (Success) {
          setUsers(
            Result.filter((item) => item.IdUsuario === registeredUserId)
          );
        }
      } catch (error) {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "58",
          screen: "Usuários",
          problem: `Erro na chamada do endpoint list-user - ${error}`,
        });
      } finally {
        setIsSearchingRegisteredUser(false);
      }
    };

    if (registeredUserId) {
      fetchList();
    }
  }, [registeredUserId]);

  const handleVerifyBrands = () => {
    if (brands && !marcaPedido && !marcaTitulo && !marcaNotaFiscal) {
      if (brands?.length !== 0 && brands?.length !== 1) {
        setMarcaPedido(brandDefaultValue);
        setMarcaTitulo(brandDefaultValue);
        setMarcaNotaFiscal(brandDefaultValue);
      } else if (brands?.length === 1) {
        setMarcaPedido(brands[0]);
        setMarcaTitulo(brands[0]);
        setMarcaNotaFiscal(brands[0]);
      }
    }
  };

  useEffect(() => {
    if (clearFilters) {
      handleVerifyBrands();
      setPeriodoPedidos(null);
      setDataInicialPedidos(dataHoje);
      setDataFinalPedidos(dataHoje);
      setPeriodoNotasFiscais(null);
      setDataInicialNotasFiscais(dataHoje);
      setDataFinalNotasFiscais(dataHoje);
      setInvoiceStatus("");
      setPeriodoTitulos(null);
      setDataInicialTitulos(dataHoje);
      setDataFinalTitulos(dataHoje);
      setPeriodoFinanceiro(financialPeriod[0]);
      setStatusFinanceiro(financialStatus[4]);
    }
  }, [clearFilters]);

  useEffect(() => {
    const verifyProfiles = JSON.parse(localStorage.getItem("userProfiles"));
    const verifyProfilesVision = JSON.parse(
      localStorage.getItem("userProfilesVision")
    );
    const profile = verifyProfilesVision
      ? verifyProfilesVision
      : verifyProfiles;

    profile.map((profile) => {
      if (
        profile.NomePerfil === "LOJA_MM" ||
        profile.NomePerfil === "LOJA_ADM_MM" ||
        profile.NomePerfil === "PILOTO_MM" ||
        profile.NomePerfil === "PILOTO_ADM_MM" ||
        profile.NomePerfil === "BACKOFFICE_MM"
      ) {
        setShowCreditLimit(false);
      }
    });
  }, []);

  useEffect(() => {
    const verifyProfiles = JSON.parse(localStorage.getItem("userProfiles"));
    const verifyMenuUser = JSON.parse(localStorage.getItem("viewsMenuUser"));
    const verifyProfilesVision = JSON.parse(
      localStorage.getItem("userProfilesVision")
    );
    const verifyMenuUserVision = JSON.parse(
      localStorage.getItem("viewsMenuUserVision")
    );
    const verifyTutorialStepOne = localStorage.getItem("lojistaStep1");

    const viewMenu = verifyMenuUserVision
      ? verifyMenuUserVision
      : verifyMenuUser;
    const profileUser = verifyProfilesVision
      ? verifyProfilesVision
      : verifyProfiles;

    viewMenu?.map((menu) => {
      profileUser.map((profile) => {
        if (
          profile?.NomePerfil === "LOJA_MM" ||
          profile?.NomePerfil === "LOJA_ADM_MM" ||
          profile?.NomePerfil === "LOJA" ||
          profile?.NomePerfil === "ADM"
        ) {
          if (
            menu?.NomeMenu === "Lojista 360" &&
            !verifyTutorialStepFour &&
            currentStep === 1
          ) {
            if (!verifyTutorialStepOne) {
              setCurrentStep(0);
              return setIsOpen(true);
            }
          }

          if (isOpen && verifyTutorialStepOne && verifyTutorialStepFour) {
            setIsOpen(false);
          }
        }
      });
    });
  }, [currentStep]);

  const consultarCNPJ360 = (cell, row) => {
    return (
      <div>
        <IconButton
          title="Consultar CNPJ"
          size="small"
          onClick={async (e) => {
            e.preventDefault();
            setCnpj(MaskAndValid.maskCNPJ(row.CnpjCpfPessoa));

            await pesquisar(e, row.CnpjCpfPessoa);
          }}
        >
          <PageviewIcon fontSize="large"></PageviewIcon>
        </IconButton>
      </div>
    );
  };

  const toggleField = async (row, field) => {
    try {
      const res = await Api.postParams(
        "update-user",
        "adminportal",
        "?nome=" +
          row.Nome +
          "&idUsuario=" +
          row.IdUsuario.toString() +
          "&login=" +
          row.Login +
          "&backoffice=" +
          row.Backoffice.toString() +
          "&inativo=" +
          row.Inativo.toString(),
        true
      );
      if (res.Success) {
        if (field === "Inativo") {
          snackbar.showMessage(
            `Usuário ${res.Result.IdUsuario.toString()} foi ${
              res.Result.Inativo ? "inativado" : "ativado"
            } com sucesso!`,
            {
              severity: "success",
            }
          );
        } else if (field === "Backoffice") {
          snackbar.showMessage(
            `Backoffice do Usuário ${res.Result.IdUsuario.toString()} foi ${
              res.Result.Backoffice ? "ativado" : "desativado"
            } com sucesso!`,
            {
              severity: "success",
            }
          );
        }
      } else {
        snackbar.showMessage(
          `Ocorreu um erro ao atualizar informação do Usuário ${res.Result.IdUsuario.toString()}. Verifique os parâmetros informados.`,
          {
            severity: "error",
          }
        );
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "58",
        screen: "Usuários",
        problem: `Erro na chamada do endpoint update-user - ${error}`,
      });
    }
  };

  const handleCloseInfoLojista = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfoLojista(false);
  };

  const handleCloseInfoRepresentante = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfoRepresentante(false);
  };

  const handleCloseInfoPedidos = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfoPedidos(false);
  };

  const handleCloseInfoFinanceiro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfoFinanceiro(false);
  };

  const handleCloseErroLojista = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErroLojista(false);
  };

  const handleCloseErroRepresentante = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErroRepresentante(false);
  };

  const handleCloseErroPedidos = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErroPedidos(false);
  };

  const handleCloseErroFinanceiro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErroFinanceiro(false);
  };

  async function getListStores() {
    if (!cancelLoading) {
      setPesquisandoCNPJ(true);
    }
    try {
      const value = await Api.get(
        "list-stores",
        "store",
        "?codigo=" +
          codigo +
          "&nomeContato=" +
          nomeContato +
          "&telefone=" +
          telefone +
          "&email=" +
          email +
          "&nrPedido=" +
          numeroPedido +
          "&nrProposta=" +
          numeroProposta +
          "&nrNF=" +
          numeroNF +
          "&cnpjRepresentante=" +
          cnpjRepresentante +
          (periodoCompraSellIn !== ""
            ? "&codProdutoComCompra=" +
              codigoProduto +
              "dtIniComCompra" +
              dataInicialCompraSellin +
              "dtFimComCompra" +
              dataFinalCompraSellin
            : ""),
        true
      );
      setListStores(value.Result);
    } catch (error) {
      if (!cancelLoading) {
        snackbar.showMessage(error, {
          severity: "error",
        });
      }
      console.log(error);
      setLocalStorageApiProblem({
        idMenuAccess: "10",
        screen: "Lojista 360",
        problem: `Erro na chamada do endpoint list-stores - ${error}`,
      });
    } finally {
      setPesquisandoCNPJ(false);
    }
  }

  const savingDataFinancial = (tableData) => {
    if (tableData?.length !== 0) {
      setStoreFinancial(tableData);
      setShowCardFinanceiro(true);
    } else {
      setStoreFinancial([]);
    }
    setPesquisandoTitulos(false);
  };

  const savingDataInvoices = (tableData) => {
    if (tableData?.length !== 0) {
      setStoreNotasFiscais(tableData);
      setShowCardNotaFiscal(true);
    } else {
      setStoreNotasFiscais([]);
    }
    setPesquisandoNotasFiscais(false);
  };

  const savingDataOrders = (tableData) => {
    if (tableData?.length !== 0) {
      setStoreListOrders(tableData);
      setShowCardPedidos(true);
    } else {
      setStoreListOrders([]);
    }
    setPesquisandoPedidos(false);
  };

  const handleSendMessageFinancial = (message) => {
    handleFetchDataFinancial(message);
  };

  const handleSendMessageInvoices = (message) => {
    handleFetchDataInvoices(message);
  };

  const handleSendMessageOrders = (message) => {
    handleFetchDataOrders(message);
  };

  function handleGetTableDataFinancial() {
    savingDataFinancial(dataFinancial);
  }

  function handleGetTableDataInvoices() {
    savingDataInvoices(dataInvoices);
  }

  function handleGetTableDataOrders() {
    savingDataOrders(dataOrders);
  }

  const handleSearchTitles = async (cnpjAtualizado) => {
    const SearchCNPJ = cnpjAtualizado ? cnpjAtualizado : cnpj;
    const removeMask = SearchCNPJ?.replace(/[^\d]+/g, "");

    const verifyMarcaTitulos =
      marcaTitulo?.IdMarca === 0
        ? "Todas"
        : marcaTitulo?.IdMarca
        ? marcaTitulo?.IdMarca
        : "Todas";

    setStoreFinancial(null);
    setLastSearchParamsTitles(null);
    setLastSearchParamsTitles({
      idMarca: verifyMarcaTitulos,
      tipoPeriodo: periodoFinanceiro?.value,
      status: statusFinanceiro?.value,
      cnpj: removeMask,
      dtIni: dataInicialTitulos,
      dtFim: dataFinalTitulos,
    });
  };

  const handleSearchNotes = async (cnpjAtualizado) => {
    const SearchCNPJ = cnpjAtualizado ? cnpjAtualizado : cnpj;
    const removeMask = SearchCNPJ?.replace(/[^\d]+/g, "");

    const verifyMarcaNotas =
      marcaNotaFiscal?.IdMarca === 0
        ? "Todas"
        : marcaNotaFiscal?.IdMarca
        ? marcaNotaFiscal?.IdMarca
        : "Todas";

    setStoreNotasFiscais(null);
    setLastSearchParamsNotasFiscais(null);
    setLastSearchParamsNotasFiscais({
      idMarca: verifyMarcaNotas,
      status: invoiceStatus || "",
      cnpj: removeMask,
      dtIni: dataInicialNotasFiscais,
      dtFim: dataFinalNotasFiscais,
      numeroNf: numeroNF,
      consultaNotas: "true",
    });
  };

  const handleSearchOrders = async (cnpjAtualizado) => {
    setPesquisandoPedidos(true);

    const SearchCNPJ = cnpjAtualizado ? cnpjAtualizado : cnpj;
    const removeMask = SearchCNPJ?.replace(/[^\d]+/g, "");

    const verifyMarcaPedido =
      marcaPedido?.IdMarca === 0
        ? "Todas"
        : marcaPedido?.IdMarca
        ? marcaPedido?.IdMarca
        : "Todas";

    setStoreListOrders(null);
    setLastSearchParamsOrders(null);
    setLastSearchParamsOrders({
      idMarca: verifyMarcaPedido,
      dtIni: dataInicialPedidos,
      dtFim: dataFinalPedidos,
      cnpj: removeMask,
    });
  };

  useEffect(() => {
    if (lastSearchParamsTitles && userId) {
      setPesquisandoTitulos(true);
      handleSendMessageFinancial({
        action: "store-financial-docs",
        params: {
          querystring: lastSearchParamsTitles,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [lastSearchParamsTitles, userId]);

  useEffect(() => {
    if (lastSearchParamsNotasFiscais && userId && valueTab360 === "3") {
      setPesquisandoNotasFiscais(true);
      handleSendMessageInvoices({
        action: "list-invoices-store",
        params: {
          querystring: lastSearchParamsNotasFiscais,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [lastSearchParamsNotasFiscais, userId]);

  useEffect(() => {
    if (
      lastSearchParamsOrders &&
      userId &&
      ((!pesquisandoTitulos &&
        !pesquisandoNotasFiscais &&
        valueTab360 === "1") ||
        valueTab360 === "2")
    ) {
      handleSendMessageOrders({
        action: "list-orders-store",
        params: {
          querystring: lastSearchParamsOrders,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [
    lastSearchParamsOrders,
    userId,
    pesquisandoNotasFiscais,
    pesquisandoTitulos,
  ]);

  useEffect(() => {
    if (
      statusOrders === "empty" &&
      !cancelLoading &&
      ((!pesquisando && storeListOrders?.length === 0) ||
        (pesquisando && storeListOrders === null))
    ) {
      snackbar.showMessage("Sua busca não retornou nenhum pedido.", {
        severity: "success",
      });
      setPesquisandoPedidos(false);
      setShowCardPedidos(true);
    } else if (
      statusOrders === "close" ||
      (storeListOrders?.length === 0 && !pesquisando)
    ) {
      setTimeout(() => {
        setPesquisandoPedidos(false);
        setShowCardPedidos(true);
      }, 1000);
    }
  }, [
    statusOrders,
    cancelLoading,
    pesquisando,
    pesquisandoPedidos,
    storeListOrders,
    dataOrders,
  ]);

  useEffect(() => {
    if (
      statusInvoices === "empty" &&
      !cancelLoading &&
      ((!pesquisando && storeNotasFiscais?.length === 0) ||
        (pesquisando && storeNotasFiscais === null))
    ) {
      snackbar.showMessage("Sua busca não retornou nenhuma nota fiscal.", {
        severity: "success",
      });
      setPesquisandoNotasFiscais(false);
      setShowCardNotaFiscal(true);
    } else if (
      statusInvoices === "close" ||
      (storeNotasFiscais?.length === 0 && !pesquisando)
    ) {
      setTimeout(() => {
        setPesquisandoNotasFiscais(false);
        setShowCardNotaFiscal(true);
      }, 1000);
    }
  }, [
    statusInvoices,
    cancelLoading,
    pesquisando,
    pesquisandoNotasFiscais,
    storeNotasFiscais,
  ]);

  useEffect(() => {
    if (
      statusFinancial === "empty" &&
      !cancelLoading &&
      ((!pesquisando && storeFinancial?.length === 0) ||
        (pesquisando && storeFinancial === null))
    ) {
      snackbar.showMessage("Sua busca não retornou nenhum título financeiro.", {
        severity: "success",
      });
      setPesquisandoTitulos(false);
      setShowCardFinanceiro(true);
    } else if (
      statusFinancial === "close" ||
      (storeFinancial?.length === 0 && !pesquisando)
    ) {
      setTimeout(() => {
        setPesquisandoTitulos(false);
        setShowCardFinanceiro(true);
      }, 1000);
    }
  }, [
    statusFinancial,
    cancelLoading,
    pesquisando,
    pesquisandoTitulos,
    storeFinancial,
  ]);

  useEffect(() => {
    if (pesquisandoNotasFiscais && statusInvoices === "empty") {
      setPesquisandoNotasFiscais(false);
      setStoreNotasFiscais([]);
    }
  }, [pesquisandoNotasFiscais, statusInvoices]);

  useEffect(() => {
    if (pesquisandoPedidos && statusOrders === "empty") {
      setPesquisandoPedidos(false);
      setStoreListOrders([]);
    }
  }, [pesquisandoPedidos, statusOrders]);

  useEffect(() => {
    if (pesquisandoTitulos && statusFinancial === "empty") {
      setPesquisandoTitulos(false);
      setStoreFinancial([]);
    }
  }, [pesquisandoTitulos, statusFinancial]);

  useEffect(() => {
    handleFetchUrlFinancial(
      `wss://1g6jdi30j7.execute-api.us-east-1.amazonaws.com/${api}`
    );
    handleFetchUrlOrders(
      `wss://hdqgdmzmsb.execute-api.us-east-1.amazonaws.com/${api}`
    );
    handleFetchUrlInvoices(
      `wss://3zvsu3yj2b.execute-api.us-east-1.amazonaws.com/${api}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getStoreRegistrationData(cnpjConsulta, searchAll) {
    const _cnpj = cnpjConsulta || cnpj;
    _setCnpj(_cnpj);
    let notFoundCNPJ;
    setClearFilters(true);
    if (valueTab360 === "1" || searchAll) {
      setPesquisandoLojista(true);
      try {
        const value = await Api.get(
          "store-registration-data",
          "store",
          "?cnpj=" + _cnpj,
          true
        );
        setPesquisandoLojista(false);
        if (value.Result.IdPessoa === 0) {
          setShowCardStore(false);
          setShowCNPJNotFound(true);
          notFoundCNPJ = true;
        } else {
          setShowCardStore(true);
          setStoreRegistrationData(value.Result);
          // Rep
          setPesquisandoRepresentante(true);
          try {
            const repValue = await Api.get(
              "representante-lojista",
              "representative",
              "?cnpj=" + _cnpj,
              false
            );
            if (repValue.Result.IdPessoa === 0) {
              setMsgInfo(
                "Não foi possível retornar os dados do representante do lojista. Verifique os parâmetros informados."
              );
              setOpenInfoRepresentante(true);
              setShowCardRepresentante(false);
              setPesquisandoRepresentante(false);
            } else {
              setShowCardRepresentante(true);
              setStoreRepresentatives(repValue.Result);
              setPesquisandoRepresentante(false);
            }
          } catch (error) {
            if (!cancelLoading) {
              snackbar.showMessage(error, {
                severity: "error",
              });
            }
            setOpenErroRepresentante(true);
            console.log(error);
            setShowCardRepresentante(false);
            setPesquisandoRepresentante(false);
            setLocalStorageApiProblem({
              idMenuAccess: "10",
              screen: "Lojista 360",
              problem: `Erro na chamada do endpoint representante-lojista - ${error}`,
            });
          }
        }
      } catch (error) {
        if (!cancelLoading) {
          snackbar.showMessage(error, {
            severity: "error",
          });
        }
        setOpenErroLojista(true);
        console.log(error);
        setShowCardStore(false);
        setPesquisandoLojista(false);
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Lojista 360",
          problem: `Erro na chamada do endpoint store-financial-docs - ${error}`,
        });
      }
    }
    if (
      ((valueTab360 === "1" || valueTab360 === "2") && !notFoundCNPJ) ||
      searchAll
    ) {
      handleSearchOrders(_cnpj);
    }
    if ((valueTab360 === "3" && !notFoundCNPJ) || searchAll) {
      handleSearchNotes(_cnpj);
    }
    if ((valueTab360 === "4" && !notFoundCNPJ) || searchAll) {
      handleSearchTitles(_cnpj);
    }
    setClearFilters(false);
  }

  async function pesquisar(event, cnpjConsulta, searchAll) {
    setLocalStorageActions({
      nomeTela: "Lojista 360",
      idMenu: "10",
      acao: "Acessou a tela de Lojista 360",
    });
    if (event) {
      event.preventDefault();
    }
    setPesquisando(true);
    setCancelLoading(false);

    if (valueTab360 === "1") {
      setShowCardStore(false);
      setShowCNPJNotFound(false);
      setStoreRegistrationData(false);
      setShowCardRepresentante(false);
      setUsers([]);

      if (
        codigo ||
        numeroPedido ||
        numeroProposta ||
        numeroNF ||
        periodoCompraSellIn
      ) {
        pesquisarCNPJ(event);
      }
    }

    if (valueTab360 === "1" || valueTab360 === "2") {
      setShowCardPedidos(false);
    }

    if (valueTab360 === "1" || valueTab360 === "3") {
      setShowCardNotaFiscal(false);
    }

    if (valueTab360 === "1" || valueTab360 === "4") {
      setShowCardFinanceiro(false);
    }

    await getStoreRegistrationData(cnpjConsulta, searchAll);

    setPesquisando(
      pesquisandoLojista ||
        pesquisandoRepresentante ||
        pesquisandoPedidos ||
        pesquisandoTitulos
    );
  }

  async function pesquisarCNPJ(event) {
    event.preventDefault();

    setUsers([]);

    setListStores(null);
    setPesquisandoCNPJ(true);

    await getListStores();

    setPesquisandoCNPJ(false);
  }

  const handleChangeTab360 = (event, newValue) => {
    setValueTab360(newValue);
  };

  const handleGetEconomicGroupList = async () => {
    if (!verifyTutorialStepOne || verifyTutorialStepFour) {
      const groupList = JSON.parse(
        localStorage.getItem("visao360EconomicGroupList")
      );
      setLoadingGroupName(true);
      if (groupList) {
        setGroupNameList(groupList);
        if (groupList?.length === 1) {
          setGroupName(groupList[0].Id);
        }
        setLoadingGroupName(false);
      } else {
        try {
          const res = await Api.get(
            `econnomical-group`,
            "commercialstructure",
            "",
            true
          );
          setGroupNameList(res.Result);
          localStorage.setItem(
            "visao360EconomicGroupList",
            JSON.stringify(res.Result)
          );
          setLoadingGroupName(false);
          if (res.Result.length === 1) {
            setGroupName(res.Result[0].Id);
          }
        } catch (e) {
          setLoadingGroupName(false);
          console.log(e);
          setLocalStorageApiProblem({
            idMenuAccess: "10",
            screen: "Lojista 360",
            problem: `Erro na chamada do endpoint econnomical-group - ${e}`,
          });
        }
      }
    }
  };

  const handleGetSocialNameList = async (page = 0) => {
    if (!verifyTutorialStepOne || verifyTutorialStepFour) {
      setLoadingSocialName(true);
      try {
        const res = await Api.get(
          "store-user",
          "commercialstructure",
          `?page=${page}&filtro=${debouncedStoreFilter || ""}&pageSize=1000` +
          (groupName ? `&idGrupoEconomico=${groupName.Id}` : ""),
          true
        );
        if (page === 0) {
          setSocialNameList(res.Result.ListLojas);
        } else {
          setSocialNameList((s) => [...s, ...res.Result.ListLojas]);
        }
        setLoadingSocialName(false);
        if (
          debouncedStoreFilter.length >= 3 &&
          res.Result.TotalDePaginas > page
        ) {
          handleGetSocialNameList(page + 1);
        }
      } catch (e) {
        setLoadingSocialName(false);
        console.log(e);
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Lojista 360",
          problem: `Erro na chamada do endpoint store - ${e}`,
        });
      }
    }
  };

  const handleGetStatusInvoices = async () => {
    const invoiceStatusStorage = JSON.parse(
      localStorage.getItem("invoiceStatus360")
    );
    if (invoiceStatusStorage) {
      setInvoiceStatisList(invoiceStatusStorage);
    } else {
      if (!verifyTutorialStepOne || verifyTutorialStepFour) {
        try {
          const res = await Api.get(`invoices-status`, "invoice", "", true);
          setInvoiceStatisList(res.Result);
          localStorage.setItem("invoiceStatus360", JSON.stringify(res.Result));
          if (res.Result.length === 1) {
            setInvoiceStatisList(res.Result[0].Id);
          }
        } catch (error) {
          if (!cancelLoading) {
            snackbar.showMessage(error, {
              severity: "error",
            });
          }
          setLocalStorageApiProblem({
            idMenuAccess: "10",
            screen: "Lojista 360",
            problem: `Erro na chamada do endpoint invoices-status - ${error}`,
          });
        }
      }
    }
  };

  const handleStopSearching = () => {
    setLocalStorageActions({
      nomeTela: "Lojista 360",
      idMenu: "10",
      acao: "Clicou para parar busca de dados",
    });
    setCancelLoading(true);
    if (valueTab360 === "1") {
      setStoreRegistrationData(null);
      setPesquisandoLojista(false);
      setPesquisando(false);
      setPesquisandoRepresentante(false);
      setPesquisandoPedidos(false);
      setPesquisandoTitulos(false);
      setPesquisandoNotasFiscais(false);
    } else if (valueTab360 === "2") {
      setPesquisandoPedidos(false);
      handleFetchUrlOrders("");
      setTimeout(() => {
        handleFetchUrlOrders(
          `wss://hdqgdmzmsb.execute-api.us-east-1.amazonaws.com/${api}`
        );
      }, 1000);
    } else if (valueTab360 === "3") {
      setPesquisandoNotasFiscais(false);
      handleFetchUrlInvoices("");
      setTimeout(() => {
        handleFetchUrlInvoices(
          `wss://3zvsu3yj2b.execute-api.us-east-1.amazonaws.com/${api}`
        );
      }, 1000);
    } else if (valueTab360 === "4") {
      setPesquisandoTitulos(false);
      handleFetchUrlFinancial("");
      setTimeout(() => {
        handleFetchUrlFinancial(
          `wss://1g6jdi30j7.execute-api.us-east-1.amazonaws.com/${api}`
        );
      }, 1000);
    }
    setCancelLoading(false);
  };

  const handleClearFilters = () => {
    setLocalStorageActions({
      nomeTela: "Lojista 360",
      idMenu: "10",
      acao: "Clicou para limpar filtros",
    });
    if (valueTab360 === "1") {
      setUsers([]);

      setClearFilters(true);
      setLoadingGroupName(true);
      setGroupName(null);
      setSocialName("");
      setCnpj("");
      setShowCardStore(false);
      setShowCNPJNotFound(false);
      setCodigo("");
      setNumeroPedido("");
      setNumeroProposta("");
      setNumeroNF("");
      setPeriodoCompraSellIn(null);
      setStoreRegistrationData(false);
      setShowCardRepresentante(false);
      setTimeout(() => {
        setClearFilters(false);
        setLoadingGroupName(false);
      }, 500);
      setNomeContato("");
      setTelefone("");
      setEmail("");
      setCnpjRepresentante("");
      setCodigoProduto("");
      setDataInicialCompraSellin(dataHoje);
      setDataFinalCompraSellin(dataHoje);
    } else if (valueTab360 === "2") {
      setClearFiltersTab2(true);
      setPeriodoPedidos(30);
      setDataInicialPedidos(dataHoje);
      setDataFinalPedidos(dataHoje);
      setMarcaPedido(
        brands.length === 1
          ? brands[0]
          : brands?.length !== 0 && brands?.length !== 1
          ? brandDefaultValue
          : null
      );
      setShowCardPedidos(false);
      setStoreListOrders(null);
      setTimeout(() => {
        setClearFiltersTab2(false);
      }, 400);
    } else if (valueTab360 === "3") {
      setClearFiltersTab3(true);
      setPeriodoNotasFiscais(30);
      setDataInicialNotasFiscais(dataHoje);
      setDataFinalNotasFiscais(dataHoje);
      setMarcaNotaFiscal(
        brands.length === 1
          ? brands[0]
          : brands?.length !== 0 && brands?.length !== 1
          ? brandDefaultValue
          : null
      );
      setNumeroNF("");
      setInvoiceStatus("");
      setStoreNotasFiscais(null);
      setTimeout(() => {
        setClearFiltersTab3(false);
      }, 400);
    } else if (valueTab360 === "4") {
      setClearFiltersTab4(true);
      setPeriodoTitulos(30);
      setDataInicialTitulos(dataHoje);
      setDataFinalTitulos(dataHoje);
      setMarcaTitulo(
        brands.length === 1
          ? brands[0]
          : brands?.length !== 0 && brands?.length !== 1
          ? brandDefaultValue
          : null
      );
      setStatusFinanceiro(financialStatus[4]);
      setPeriodoFinanceiro(financialPeriod[0]);
      setStoreFinancial(null);
      setTimeout(() => {
        setClearFiltersTab4(false);
      }, 400);
    }
  };

  useEffect(() => {
    if (
      (valueTab360 === "3" && !storeNotasFiscais) ||
      (valueTab360 === "4" && !storeFinancial)
    ) {
      pesquisar();
    }
  }, [valueTab360]);

  useEffect(() => {
    if (socialName && cnpj?.length === 18) {
      let event;
      pesquisar(event, cnpj);
      handleFetchUrlFinancial(
        `wss://1g6jdi30j7.execute-api.us-east-1.amazonaws.com/${api}`
      );
      handleFetchUrlOrders(
        `wss://hdqgdmzmsb.execute-api.us-east-1.amazonaws.com/${api}`
      );
      handleFetchUrlInvoices(
        `wss://3zvsu3yj2b.execute-api.us-east-1.amazonaws.com/${api}`
      );
    }
  }, [socialName, cnpj]);

  useEffect(() => {
    setLoadingSocialName(false);

    if (groupName) {
      setSocialName("");
      setCnpj("");
      setSocialNameList([]);
    }
  }, [groupName]);

  useEffect(() => {
    handleGetEconomicGroupList();
    handleGetStatusInvoices();
  }, []);

  useEffect(() => {
    handleGetSocialNameList();
  }, [debouncedStoreFilter, groupName]);

  useEffect(() => {
    if (storeRegistrationData?.CnpjCpfPessoa) {
      const unformattedCnpj = storeRegistrationData.CnpjCpfPessoa?.replace(
        /([-./])+/g,
        ""
      );
      const fetchCreditLimit = async () => {
        try {
          const data = await Api.get(
            "get-info-credit-limit",
            "sellincreditlimit",
            "?cnpj=" + unformattedCnpj,
            true
          );
          if (data.Result) {
            setDadosBignumberFinanceiro({
              limiteAdotado: MaskAndValid.maskPrice(
                data.Result.LimiteCreditoAdotado
              ),
              limiteTomado: MaskAndValid.maskPrice(
                data.Result.LimiteCreditoTomado
              ),
              limiteDisponivel: MaskAndValid.maskPrice(
                data.Result.LimiteCreditoDisponivel
              ),
            });
          }
        } catch (error) {
          setDadosBignumberFinanceiro({
            limiteAdotado: null,
            limiteTomado: null,
            limiteDisponivel: null,
          });
          if (showCreditLimit && !cancelLoading) {
            snackbar.showMessage(error, {
              severity: "error",
            });
          }
          setLocalStorageApiProblem({
            idMenuAccess: "10",
            screen: "Lojista 360",
            problem: `Erro na chamada do endpoint get-info-credit-limit - ${error}`,
          });
        }
      };
      fetchCreditLimit();
    }
  }, [storeRegistrationData]);

  useEffect(() => {
    handleVerifyBrands();
  }, [brands, brandDefaultValue]);

  return (
    <>
      <HeaderClientes section="Lojista 360°" subsection="Clientes" />

      <Container maxWidth={false} style={{ marginTop: "-4rem" }}>
        <FilterCard
          handleSearch={(e) => {
            if (
              !(
                !MaskAndValid.validateCNPJ(cnpj) ||
                pesquisandoLojista ||
                pesquisandoRepresentante ||
                pesquisandoPedidos ||
                pesquisandoNotasFiscais ||
                pesquisandoTitulos ||
                loadingGroupName ||
                loadingSocialName ||
                pesquisandoCNPJ
              )
            ) {
              pesquisar(e);
            }
            if (codigo || numeroPedido || numeroNF || numeroProposta) {
              pesquisarCNPJ(e);
            }
          }}
          searching={pesquisando}
          disabled={
            (!MaskAndValid.validateCNPJ(cnpj) ||
              pesquisandoLojista ||
              pesquisandoRepresentante ||
              pesquisandoPedidos ||
              pesquisandoNotasFiscais ||
              pesquisandoTitulos ||
              loadingGroupName ||
              loadingSocialName ||
              pesquisandoCNPJ) &&
            !codigo &&
            !numeroPedido &&
            !numeroNF &&
            !numeroProposta
          }
          handleClearFilters={handleClearFilters}
          bottonInfo={
            <>
              {valueTab360 === "1" && groupName && !socialName && (
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ color: "grey", marginTop: "1rem" }}
                >
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                    style={{
                      fontSize: "1rem",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                  É necessário selecionar uma Razão Social / Loja para realizar
                  a pesquisa.
                </Typography>
              )}
            </>
          }
        >
          <>
            {valueTab360 === "1" ? (
              <>
                <Grid item xs={itemXSResponsive} style={{ marginBottom: "0" }}>
                  <AutoCompleteField
                    label="Nome do Grupo"
                    onChange={(value) => {
                      if (value === "all") {
                        setGroupName(null);
                        setSocialName("");
                        setCnpj("");
                        setSocialNameList([]);
                      } else {
                        setGroupName(value);
                        setSocialName("");
                      }
                    }}
                    options={groupNameList}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoTitulos ||
                      groupNameList.length === 1
                    }
                    loading={loadingGroupName}
                    value={groupName}
                  />
                </Grid>

                <Grid item xs={itemXS6} style={{ marginBottom: "0" }}>
                  <AutoCompleteField
                    label="Razão Social / Loja"
                    onChange={(value) => {
                      setStoreFinancial(null);
                      setStoreNotasFiscais(null);
                      if (value === "all") {
                        setCnpj("");
                        setSocialName("");
                      } else {
                        setCnpj(MaskAndValid.maskCNPJ(value.CNPJ));
                        setSocialName(value);
                      }
                    }}
                    options={socialNameList}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoTitulos ||
                      loadingGroupName
                    }
                    loading={loadingSocialName}
                    value={socialName}
                  />
                </Grid>

                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="CNPJ"
                    placeholder="00.000.000/0000-00"
                    value={cnpj}
                    onChange={(e) => {
                      setCnpj(
                        MaskAndValid.maskCNPJ(e.target.value.slice(0, 18))
                      );
                      setStoreFinancial(null);
                      setStoreNotasFiscais(null);
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        MaskAndValid.validateCNPJ(cnpj)
                      ) {
                        pesquisar(e);
                      }
                    }}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoTitulos ||
                      loadingSocialName ||
                      loadingGroupName
                    }
                  />
                </Grid>

                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="Código ERP"
                    type="number"
                    value={codigo}
                    onChange={(e) => {
                      setCodigo(e.target.value.slice(0, 9));
                    }}
                    disabled={pesquisandoCNPJ}
                    placeholder="Digite o código ERP"
                  />
                </Grid>

                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="Número do pedido"
                    type="number"
                    value={numeroPedido}
                    onChange={(e) => {
                      setNumeroPedido(e.target.value.slice(0, 20));
                    }}
                    disabled={pesquisandoCNPJ}
                    placeholder="Digite o número do pedido"
                  />
                </Grid>

                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="Proposta"
                    value={numeroProposta}
                    onChange={(e) => {
                      setNumeroProposta(e.target.value.slice(0, 20));
                    }}
                    disabled={pesquisandoCNPJ}
                    placeholder="Digite o número da proposta"
                  />
                </Grid>

                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="Número da NF"
                    type="number"
                    value={numeroNF}
                    onChange={(e) => {
                      setNumeroNF(e.target.value.slice(0, 50));
                    }}
                    disabled={pesquisandoCNPJ}
                    placeholder="Digite o número da NF"
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid
                  item
                  xs={itemXS6}
                  style={{
                    alignSelf: "flex-start",
                    marginBottom: isMobile && "0.75rem",
                    padding: "6px 15px",
                  }}
                >
                  <FormLabel>Lojista</FormLabel>
                  <Typography variant="body2">
                    {storeRegistrationData.Apelido}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={itemXS6}
                  style={{
                    alignSelf: "flex-start",
                    marginBottom: isMobile && "0.75rem",
                    padding: "6px 15px",
                  }}
                >
                  <FormLabel>CNPJ</FormLabel>
                  <Typography variant="body2">
                    {MaskAndValid.maskCNPJ(storeRegistrationData.CnpjCpfPessoa)}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={itemXS6}
                  style={{
                    alignSelf: "flex-start",
                    marginBottom: isMobile && "0.75rem",
                    padding: "6px 15px",
                  }}
                >
                  <FormLabel>Telefone</FormLabel>
                  <Typography variant="body2">
                    <PhoneWithWhatsapp
                      phone={storeRegistrationData.FonePrincipal}
                    />
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={itemXS6}
                  style={{
                    alignSelf: "flex-start",
                    marginBottom: isMobile && "0.75rem",
                    padding: "6px 15px",
                  }}
                >
                  <FormLabel>E-mail</FormLabel>
                  <Typography variant="body2">
                    <EmailWithCopyAndSend
                      email={storeRegistrationData.EmailPrincipal}
                      showCopy
                      showSend
                    />
                  </Typography>
                </Grid>
                {storeRegistrationData.LojasGrupoEconomico &&
                  storeRegistrationData.LojasGrupoEconomico.length > 1 && (
                    <Grid
                      item
                      xs={itemXS6}
                      style={{
                        alignSelf: "flex-start",
                        marginBottom: isMobile && "0.75rem",
                        padding: "6px 15px",
                      }}
                    >
                      <EditableEconomicGroupStore
                        stores={storeRegistrationData.LojasGrupoEconomico}
                        changeStore={pesquisar}
                        mobile={isMobile}
                        mobile1100={isMobile1100}
                      />
                    </Grid>
                  )}
              </>
            )}

            <Grid xs={12}>
              <Divider style={{ margin: "1rem 0" }} />
            </Grid>

            {valueTab360 === "1" && (
              <Grid
                item
                xs={12}
                sm={periodoCompraSellIn?.value === "Outros" ? 12 : 4}
              >
                <PeriodField
                  label="Período Compra Sellin"
                  value={periodoCompraSellIn}
                  onChange={setPeriodoCompraSellIn}
                  initialDate={dataInicialCompraSellin}
                  finalDate={dataFinalCompraSellin}
                  setInitialDate={setDataInicialCompraSellin}
                  setFinalDate={setDataFinalCompraSellin}
                  disabled={pesquisandoCNPJ}
                />
              </Grid>
            )}

            {valueTab360 === "2" && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={periodoPedidos?.value === "Outros" ? 8 : 4}
                >
                  <PeriodField
                    label="Período de Emissão"
                    value={periodoPedidos}
                    onChange={setPeriodoPedidos}
                    initialDate={dataInicialPedidos}
                    finalDate={dataFinalPedidos}
                    setInitialDate={setDataInicialPedidos}
                    setFinalDate={setDataFinalPedidos}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                  />
                </Grid>
                <Grid item xs={itemXSResponsive}>
                  <AutoCompleteField
                    options={brands}
                    onChange={setMarcaPedido}
                    label="Marca"
                    optionIdKey="IdMarca"
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                    loading={clearFilters || clearFiltersTab2}
                    value={marcaPedido}
                  />
                </Grid>
              </>
            )}

            {valueTab360 === "3" && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={periodoNotasFiscais?.value === "Outros" ? 12 : 3}
                >
                  <PeriodField
                    label="Período de Emissão"
                    value={periodoNotasFiscais}
                    onChange={setPeriodoNotasFiscais}
                    initialDate={dataInicialNotasFiscais}
                    finalDate={dataFinalNotasFiscais}
                    setInitialDate={setDataInicialNotasFiscais}
                    setFinalDate={setDataFinalNotasFiscais}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                  />
                </Grid>
                <Grid item xs={itemXSResponsive}>
                  <InputText
                    label="Número da NF"
                    value={numeroNF}
                    onChange={(e) => setNumeroNF(e.target.value.slice(0, 7))}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                    placeholder="Digite o número da NF"
                  />
                </Grid>
                <Grid item xs={itemXSResponsive}>
                  <AutoCompleteField
                    options={brands}
                    onChange={setMarcaNotaFiscal}
                    label="Marca"
                    optionIdKey="IdMarca"
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                    loading={clearFilters || clearFiltersTab2}
                    value={marcaNotaFiscal}
                  />
                </Grid>
                <Grid item xs={itemXSResponsive}>
                  <AutoCompleteField
                    options={invoiceStatusList}
                    label="Status"
                    value={invoiceStatus}
                    onChange={(value) => {
                      setInvoiceStatus(value);
                    }}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos ||
                      invoiceStatusList.length === 1
                    }
                    loading={clearFilters || clearFiltersTab3}
                    optionLabelKey="Status"
                    optionIdKey="Status"
                  />
                </Grid>
              </>
            )}

            {valueTab360 === "4" && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={periodoTitulos?.value === "Outros" ? 8 : 3}
                >
                  <PeriodField
                    label="Período de Emissão"
                    value={periodoTitulos}
                    onChange={setPeriodoTitulos}
                    initialDate={dataInicialTitulos}
                    finalDate={dataFinalTitulos}
                    setInitialDate={setDataInicialTitulos}
                    setFinalDate={setDataFinalTitulos}
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                  />
                </Grid>
                <Grid item xs={itemXSResponsive}>
                  <AutoCompleteField
                    options={brands}
                    onChange={setMarcaTitulo}
                    label="Marca"
                    optionIdKey="IdMarca"
                    disabled={
                      pesquisandoLojista ||
                      pesquisandoRepresentante ||
                      pesquisandoPedidos ||
                      pesquisandoNotasFiscais ||
                      pesquisandoTitulos
                    }
                    loading={clearFilters || clearFiltersTab2}
                    value={marcaTitulo}
                  />
                </Grid>
              </>
            )}
          </>
        </FilterCard>

        {showCNPJNotFound && (
          <Card>
            <NotFound title="Sua pesquisa não encontrou nenhum lojista correspondente." />
          </Card>
        )}

        {(showCardStore || storeRegistrationData) && !cancelLoading && (
          <Card>
            <CardContent>
              <TabContext value={valueTab360}>
                <AppBar
                  className={classes.appBar}
                  position="static"
                  color="transparent"
                  style={{
                    marginTop: "0px",
                    backgroundColor: "white",
                    boxShadow: "none",
                  }}
                >
                  <TabList
                    onChange={handleChangeTab360}
                    centered={isMobile ? true : false}
                    variant={"scrollable"}
                    scrollButtons="on"
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Lojista 360",
                          idMenu: "10",
                          acao: "Clicou na aba Dados Cadastrais",
                        });
                      }}
                      className={classes.tab}
                      disabled={
                        pesquisandoLojista ||
                        pesquisandoRepresentante ||
                        pesquisandoPedidos ||
                        pesquisandoNotasFiscais ||
                        pesquisandoTitulos
                      }
                      label="Dados Cadastrais"
                      value="1"
                    />
                    <Tab
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Lojista 360",
                          idMenu: "10",
                          acao: "Clicou na aba Pedidos",
                        });
                      }}
                      className={classes.tab}
                      disabled={
                        pesquisandoLojista ||
                        pesquisandoRepresentante ||
                        pesquisandoPedidos ||
                        pesquisandoNotasFiscais ||
                        pesquisandoTitulos ||
                        statusOrders === "fetching"
                      }
                      label="Pedidos"
                      value="2"
                    />
                    <Tab
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Lojista 360",
                          idMenu: "10",
                          acao: "Clicou na aba Notas Fiscais",
                        });
                      }}
                      className={classes.tab}
                      disabled={
                        pesquisandoLojista ||
                        pesquisandoRepresentante ||
                        pesquisandoPedidos ||
                        pesquisandoNotasFiscais ||
                        pesquisandoTitulos ||
                        statusInvoices === "fetching"
                      }
                      label="Notas Fiscais"
                      value="3"
                    />
                    <Tab
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Lojista 360",
                          idMenu: "10",
                          acao: "Clicou na aba Títulos Financeiros",
                        });
                      }}
                      className={classes.tab}
                      disabled={
                        pesquisandoLojista ||
                        pesquisandoRepresentante ||
                        pesquisandoPedidos ||
                        pesquisandoNotasFiscais ||
                        pesquisandoTitulos ||
                        statusFinancial === "fetching"
                      }
                      label="Títulos Financeiros"
                      value="4"
                    />
                  </TabList>
                </AppBar>
              </TabContext>
            </CardContent>
          </Card>
        )}

        <Grid container spacing={2}>
          {valueTab360 === "1" && (
            <DadosGeraisView
              hasAccessToUserRegister={hasAccessToUserRegister}
              users={users}
              setSelectedUser={setSelectedUser}
              setFormType={setFormType}
              toggleField={toggleField}
              formType={formType}
              selectedUser={selectedUser}
              storeRegistrationData={storeRegistrationData}
              showCardStore={showCardStore}
              cancelLoading={cancelLoading}
              isMobile800={isMobile}
              registeredUserId={registeredUserId}
              setFormTypeCreate={() => setFormType("create")}
              showCardRepresentante={showCardRepresentante}
              storeRepresentatives={storeRepresentatives}
              pesquisandoLojista={pesquisandoLojista}
              handleStopSearching={handleStopSearching}
              pesquisandoCNPJ={pesquisandoCNPJ}
              classes={classes}
              isSearchingRegisteredUser={isSearchingRegisteredUser}
              setIsSearchingRegisteredUser={setIsSearchingRegisteredUser}
              setUsers={setUsers}
              setRegisteredUserId={setRegisteredUserId}
              listStores={listStores}
              consultarCNPJ360={consultarCNPJ360}
            />
          )}
          {valueTab360 === "2" && (
            <PedidosView
              showCardPedidos={showCardPedidos}
              cancelLoading={cancelLoading}
              storeListOrders={storeListOrders}
              pesquisandoPedidos={pesquisandoPedidos}
              periodoPedidosLabel={getPeriodLabel({
                period: periodoPedidos?.value,
                initialDate: dataInicialPedidos,
                finalDate: dataFinalPedidos,
              })}
              handleSearchOrders={handleSearchOrders}
              _cnpj={_cnpj}
              itemXSBigNumbersPedidos={itemXSBigNumbersPedidos}
              handleStopSearching={handleStopSearching}
            />
          )}

          {valueTab360 === "3" && (
            <NotasFiscaisView
              showCardNotaFiscal={showCardNotaFiscal}
              cancelLoading={cancelLoading}
              storeNotasFiscais={storeNotasFiscais}
              pesquisandoNotasFiscais={pesquisandoNotasFiscais}
              periodoNotasFiscaisTituloLabel={getPeriodLabel({
                period: periodoNotasFiscais?.value,
                initialDate: dataInicialNotasFiscais,
                finalDate: dataFinalNotasFiscais,
              })}
              handleStopSearching={handleStopSearching}
            />
          )}

          {valueTab360 === "4" && (
            <TitulosFinanceirosView
              showCardFinanceiro={showCardFinanceiro}
              cancelLoading={cancelLoading}
              storeFinancial={storeFinancial}
              pesquisandoTitulos={pesquisandoTitulos}
              periodoTitulosLabel={getPeriodLabel({
                period: periodoTitulos?.value,
                initialDate: dataInicialTitulos,
                finalDate: dataFinalTitulos,
              })}
              storeRegistrationData={storeRegistrationData}
              showCreditLimit={showCreditLimit}
              dadosBignumberFinanceiro={dadosBignumberFinanceiro}
              itemXSBigNumbersTitulos={itemXSBigNumbersTitulos}
              handleStopSearching={handleStopSearching}
            />
          )}
        </Grid>

        {!cancelLoading && (
          <>
            <Snackbar
              text={msgInfo}
              open={openInfoLojista}
              autoHideDuration={6000}
              onClose={handleCloseInfoLojista}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="info"
              style={{ backgroundColor: "#5e72e4" }}
            />
            <Snackbar
              text={msgInfo}
              open={openInfoRepresentante}
              autoHideDuration={6000}
              onClose={handleCloseInfoRepresentante}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="info"
              style={{ backgroundColor: "#5e72e4" }}
            />
            <Snackbar
              text={msgInfo}
              open={openInfoPedidos}
              autoHideDuration={6000}
              onClose={handleCloseInfoPedidos}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="info"
              style={{ backgroundColor: "#5e72e4" }}
            />
            <Snackbar
              text={msgInfo}
              open={openInfoFinanceiro}
              autoHideDuration={6000}
              onClose={handleCloseInfoFinanceiro}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="info"
              style={{ backgroundColor: "#5e72e4" }}
            />
            <Snackbar
              text={msgErro}
              open={openErroLojista}
              autoHideDuration={6000}
              onClose={handleCloseErroLojista}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="error"
            />
            <Snackbar
              text={msgErro}
              open={openErroRepresentante}
              autoHideDuration={6000}
              onClose={handleCloseErroRepresentante}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="error"
            />
            <Snackbar
              text={msgErro}
              open={openErroPedidos}
              autoHideDuration={6000}
              onClose={handleCloseErroPedidos}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="error"
            />
            <Snackbar
              text={msgErro}
              open={openErroFinanceiro}
              autoHideDuration={6000}
              onClose={handleCloseErroFinanceiro}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="error"
            />
          </>
        )}
      </Container>
    </>
  );
}
